var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex d-flex-r align-center spinner-wrapper",style:(_vm.backgroundStyle)},[_c('span',{staticClass:"loader",style:(_vm.style)}),(_vm.label)?_c('label',{style:(_vm.labelStyle)},[_vm._v(_vm._s(_vm.label))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }